// extracted by mini-css-extract-plugin
export default {"root":"DishesTableSaleType_root__9JNAE","dropdownContainer":"DishesTableSaleType_dropdownContainer__2N36c","placeHolderShimmer":"DishesTableSaleType_placeHolderShimmer__SR4L6"};